import ApiService from "../../api.service";
import API from "../../API";

export const UPLOAD_FONT_BY_TEMPLATE = 'getFontByTemplate'
export const GET_ALL_FONT = 'getAllFont'
export const SET_LIST_FONTS = 'setListFonts'
const state = {
    fonts: [],
};

const getters = {
    fonts(state) {
        return state.fonts;
    },
};

export const actions = {
    [UPLOAD_FONT_BY_TEMPLATE](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`${API.UPLOAD_FONT_BY_TEMPLATE}`,payload).then(({data}) => {
                resolve(data);
            });
        });
    },
    [GET_ALL_FONT](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_ALL_FONT}`).then(({data}) => {
                if(data.status) {
                    context.commit(SET_LIST_FONTS, data);
                }
                resolve(data);
            });
        });
    }
};

const mutations = {
    [SET_LIST_FONTS](state, data) {
        state.fonts = data.data;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
